import React, { useState } from 'react'
import { Button, Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

import { ButtonWithPromptProps } from 'types/componentTypes';
import RenderIf from 'components/components/RenderIf';
import Input from 'components/components/Input';

import './ButtonWithPrompt.scss';

const ButtonWithPrompt = (props: ButtonWithPromptProps) => {
  const {
    className,
    promptPlaceholder,
    promptLabel,
    onFinish,
    onCancel,
    onPromptDisplay,
    children,
    promptActiveBtnText,
    promptActiveClassName,
    defaultOpen,
    disabled,
  } = props;

  const [form] = Form.useForm();
  const [pending, setPending] = useState(false);
  const [promptActive, setPromptActive] = useState(defaultOpen || false);

  const handleSubmit = async (data: { text: string }) => {
    if (pending || disabled) return;
    if (promptActive) {
      setPending(true);
      try {
        const saved = await onFinish(data.text);
        if (saved !== false) {
          form.resetFields();
          setPromptActive(false);
        }
      } finally {
        setPending(false);
      }
    } else {
      setPromptActive(true);
      onPromptDisplay!();
    }
  }

  const handleCancel = () => {
    setPromptActive(false);
    onCancel!();
  }

  const buttonClassName = (promptActive ? promptActiveClassName : className) || 'secondary-button';

  return (
    <Form onFinish={handleSubmit} className="form-standalone button-with-prompt" form={form}>
      <RenderIf condition={promptActive}>
        <Input
          label={promptLabel}
          layout="vertical"
          name="text"
        >
          <TextArea disabled={pending || disabled} rows={4} placeholder={promptPlaceholder} />
        </Input>
      </RenderIf>
      <div className="button-with-prompt__actions">
        <RenderIf condition={promptActive}>
          <Button
            className="secondary-button"
            disabled={pending || disabled}
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </RenderIf>
        <Button
          className={buttonClassName}
          htmlType="submit"
          disabled={disabled}
          loading={pending}
        >
          {promptActive ? promptActiveBtnText || children : children}
        </Button>
      </div>
    </Form>
  );
}

ButtonWithPrompt.defaultProps = {
  promptPlaceholder: '',
  onPromptDisplay: () => {},
  onCancel: () => {},
  promptActiveClassName: '',
  promptActiveBtnText: '',
  className: '',
  defaultOpen: false,
}

export default ButtonWithPrompt;
